import React from 'react';
import GeneralIcon from '../../../../../assets';

export default function DetalhesDocumento({ document, onClose, onEdit, onDelete }) {
  function getFileTypeColor(type) {
    const colors = {
      PDF: 'bg-red-100 text-red-700',
      DOC: 'bg-blue-100 text-blue-700',
      TXT: 'bg-gray-100 text-gray-700',
      IMG: 'bg-purple-100 text-purple-700'
    };
    return colors[type] || 'bg-gray-100 text-gray-700';
  }

  async function handleDownload(attachment) {
    try {
      if (attachment.file) {
        // Download directly from file object
        const url = window.URL.createObjectURL(attachment.file);
        const a = window.document.createElement('a');
        a.href = url;
        a.download = attachment.name;
        window.document.body.appendChild(a);
        a.click();
        window.document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      } else if (attachment.key) {
        // Download from IndexedDB using key
        const { getImageBlob } = await import('../../../../../services/imageStore');
        const blob = await getImageBlob(attachment.key);
        if (blob) {
          const url = window.URL.createObjectURL(blob);
          const a = window.document.createElement('a');
          a.href = url;
          a.download = attachment.name;
          window.document.body.appendChild(a);
          a.click();
          window.document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        }
      }
    } catch (error) {
      console.error('Download failed:', error);
      alert('Erro ao baixar arquivo');
    }
  }

  function handleDelete() {
    if (window.confirm('Tem certeza que deseja excluir este documento?')) {
      onDelete(document.id);
      onClose();
    }
  }

  return (
    <div className="fixed inset-0 bg-black/40 z-50 overflow-auto">
      <div className="min-h-screen flex items-start justify-center p-6">
        <div className="bg-white rounded-lg w-full max-w-md p-6 max-h-[90vh] overflow-y-auto">
          {/* Header */}
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center gap-3">
              <button onClick={onClose} className="p-2 rounded hover:bg-gray-100">
                ←
              </button>
              <h3 className="text-lg font-semibold">Detalhes do documento</h3>
            </div>
            <button
              onClick={handleDelete}
              className="text-red-500 hover:text-red-700 text-sm font-medium"
            >
              Excluir
            </button>
          </div>

          <div className="space-y-4">
            {/* Editar Documento Button */}
            <button
              onClick={() => {
                onEdit(document);
                onClose();
              }}
              className="w-full py-2 px-4 border border-purple-600 text-purple-600 rounded hover:bg-purple-50 transition font-medium"
            >
              Editar documento
            </button>

            {/* Title */}
            <div>
              <label className="block text-sm font-medium text-gray-600 mb-1">
                Título
              </label>
              <div className="text-gray-900">{document.title}</div>
            </div>

            {/* Description */}
            <div>
              <label className="block text-sm font-medium text-gray-600 mb-1">
                Descrição
              </label>
              <div className="text-gray-900">{document.description}</div>
            </div>

            {/* Category */}
            <div>
              <label className="block text-sm font-medium text-gray-600 mb-1">
                Categoria
              </label>
              <div className="text-purple-600">{document.tipo}</div>
            </div>

            {/* Text Content */}
            <div>
              <label className="block text-sm font-medium text-gray-600 mb-1">
                Conteúdo
              </label>
              <div className="text-gray-900">
                {document.textContent || 'Sem conteúdo.'}
              </div>
            </div>

            {/* Attachments */}
            {document.attachments && document.attachments.length > 0 && (
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-2">
                  Anexos
                </label>
                <div className="space-y-2">
                  {document.attachments.map(att => (
                    <div
                      key={att.id}
                      className="flex items-center justify-between p-3 border rounded hover:bg-gray-50"
                    >
                      <div className="flex items-center gap-2 flex-1 min-w-0">
                        <span className={`px-2 py-1 rounded text-xs font-medium ${getFileTypeColor(att.type)}`}>
                          {att.type}
                        </span>
                        <span className="text-sm truncate">{att.name}</span>
                      </div>
                      <button
                        onClick={() => handleDownload(att)}
                        className="text-purple-600 hover:text-purple-800 ml-2"
                        title="Baixar"
                      >
                        <GeneralIcon iconName="baixar" className="w-5 h-5" />
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
